<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Recurring Work Order"
    @on-hide="resetFormData"
  >
    <recurring-work-order-form
      :new-form="false"
      v-bind="value"
      @on-submit="update"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import RecurringWorkOrderForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringChargeEditModal',
  mixins: [formModalMixin],
  components: {
    RecurringWorkOrderForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: `recurring-work-order-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    update(data, handleUpdate) {
      handleUpdate(this.$recurringWorkOrdersAPI.update(this.value.id, data));
    },
    onSave(recurringWorkOrder) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', recurringWorkOrder);
    },
  },
};
</script>
